/**
 * Persisted Assets detailed table: start level (L1/L2/L3/location) and "only in snapshot".
 * Shared by the Detailed view and the Manage workflow accordion.
 */

export const STORAGE_KEY_CARD_ASSETS_DETAILED = 'qapp_finance_card_assets_detailed';

const DEFAULT_TABLE_START_LEVEL = 1;
const DEFAULT_SHOW_ONLY_IN_SNAPSHOT = true;

/** @returns {{ tableStartLevel: 1 | 2 | 3 | 4, showOnlyInSnapshot: boolean }} */
export const readCardAssetsDetailedState = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY_CARD_ASSETS_DETAILED);
    if (!raw) {
      return {
        tableStartLevel: DEFAULT_TABLE_START_LEVEL,
        showOnlyInSnapshot: DEFAULT_SHOW_ONLY_IN_SNAPSHOT,
      };
    }
    const data = JSON.parse(raw);
    const tableStartLevel = [1, 2, 3, 4].includes(Number(data.tableStartLevel))
      ? Number(data.tableStartLevel)
      : DEFAULT_TABLE_START_LEVEL;
    const showOnlyInSnapshot = typeof data.showOnlyInSnapshot === 'boolean'
      ? data.showOnlyInSnapshot
      : DEFAULT_SHOW_ONLY_IN_SNAPSHOT;
    return { tableStartLevel, showOnlyInSnapshot };
  } catch (_) {
    /* ignore */
  }
  return {
    tableStartLevel: DEFAULT_TABLE_START_LEVEL,
    showOnlyInSnapshot: DEFAULT_SHOW_ONLY_IN_SNAPSHOT,
  };
};

export const persistCardAssetsDetailedState = (state) => {
  try {
    localStorage.setItem(
      STORAGE_KEY_CARD_ASSETS_DETAILED,
      JSON.stringify({
        tableStartLevel: state.tableStartLevel,
        showOnlyInSnapshot: state.showOnlyInSnapshot,
      })
    );
  } catch (_) {
    /* ignore */
  }
};
